import { apiGetRootProductCategory } from '../../api/root-product-category';
import { FETCH_ROOT_PRODUCT_CATEGORY, FILTER_ROOT_PRODUCT_CATEGORY } from './root-product-category.action.types';

const fetchRootProductCategorySuccess = (result) => ({
    type: FETCH_ROOT_PRODUCT_CATEGORY,
    rootProductCategories: result.data,
    totalPage: result.last_page,
    total: result.total
});

export const fetchRootProductCategory = (filterData) => {
    return async dispatch => {
        try {
            const result = await apiGetRootProductCategory(filterData);
            dispatch(fetchRootProductCategorySuccess(result));
            return Promise.resolve();
        } catch (err) {
            return Promise.reject(err);
        }
    };
};

export const setFilterRootProductCategory = (filterData) => ({
    type: FILTER_ROOT_PRODUCT_CATEGORY,
    filterData
});